import styled from 'styled-components/macro';

export const BackButton = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  cursor: pointer;
  text-align: center;
  min-height: 20px;
  margin-left: 12px;
  margin-right: 4px;
  width: 16px;
`;

export const BackButtonImg = styled.img`
  width: 16px;
`;
